<template>

<div v-if="checked">
 <div>
    <label>Mot de passe</label>
    <a-input type="password" v-model:value="user.password" :disabled="loading"></a-input>
    <label>Confirmer votre mot de passe</label>
    <a-input type="password" v-model:value="user.password_confirmation" :disabled="loading"></a-input>
  </div>

  <div style="text-align: right; margin-top: 10px">
    <a-button
      @click="createPassword()"
      :loading="loading"
      type="primary"
      shape="round"
      ghost
    >
      Créer mot de passe
    </a-button>
  </div>
</div>
 
</template>


<script>
export default {
  name: "createPassword",
  props: {
    errorData: {
      type: Object,
    },
  },
  data: () => {
    return {
      checking: true,
      checked: false,
      loading: false,
      user: {
        password: "",
        password_confirmation: "",
      },
    };
  },
  methods: {
    async checkHash() {
      this.errorData.show = false;
      localStorage.clear();

      await this.$axios
        .get(`auth/check_hash/${this.hash}`)
        .then((r) => {
          if (r.status === 200) {
            this.checked = true
          }
        })
        .catch((e) => {
          this.errorData.message = "L'URL a expiré";
          this.errorData.show = true;
        })
        .finally(() => {
          this.checking = false;
        });
    },
    async createPassword() {
      this.loading = true;
      this.errorData.show = false;
      await this.$axios
        .post(`auth/create_password/${this.hash}`, this.user)
        .then((r) => {
          if (r.status === 200) {
            localStorage.setItem("broker_token", r.data.access_token);
            window.location.href = "/";
          }
        })
        .catch((e) => {
          this.errorData.message = e.response.data.message;
          this.errorData.show = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    hash() {
      return this.$route.params.hash;
    },
  },
  created() {
    this.checkHash();
  },
};
</script>
